const styles = {
  calendarWidget: {
    margin: '1rem 0 !important',
    display: 'flex !important',
    alignItems: 'center !important',
    flexDirection: 'column !important',
    position: 'relative !important',
    width: 'auto !important',
  },
  calendarContainer: {
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.05) !important',
    backgroundColor: '#fff',
    display: 'flex',
    width: '40em',
    position: 'absolute !important',
    top: '3.125rem !important',
    right: '0 !important',
    zIndex: 10,
  },
  fixMargins: {
    margin: '0 !important',
    justifyContent: 'center !important',
  },
  buttonBar: {
    display: 'flex !important',
    justifyItems: 'right !important',
    borderTop: 'solid .0625rem #ddd !important',
  },
  button: {
    backgroundColor: '#fff !important',
    border: 'solid .0625rem #8b9898 !important',
    borderRadius: '1.5rem !important',
    color: '#8b9898 !important',
    fontSize: '.875rem !important',
    margin: '.25rem .35rem!important',
    opacity: 1,
    padding: '.550rem .9em !important',
    fontWeight: 'normal !important',

    '&:hover': {
      backgroundColor: '#683caf !important',
      color: '#fff !important',
      opacity: 0.9,
    },

    '&:active': {
      backgroundColor: '#683caf !important',
      color: '#fff !important',
      opacity: 0.7,
    },

    '&.active': {
      backgroundColor: '#683caf !important',
      color: '#fff !important',
    },
  },
  buttonPrimary: {
    backgroundColor: '#683caf !important',
    color: '#fff !important',

    '&:hover': {
      backgroundColor: '#683caf !important',
      color: '#fff !important',
      opacity: 0.9,
    },

    '&:active': {
      backgroundColor: '#683caf !important',
      color: '#fff !important',
      opacity: 0.7,
    },
  },
  smallBtn: {
    fontSize: '.75rem !important',
    padding: '.5625rem .75rem .5625rem !important',
  },
  buttonTertiary: {
    backgroundColor: 'transparent !important',
    border: 'none !important',
    fontSize: '.75rem !important',
    marginLeft: 'auto !important',
  },
  label: {
    border: 'none !important',
    fontWeight: 'normal !important',
  },
  invalidMessage: {
    margin: '.500rem 0 0 3rem',
    color: '#f4897c',
    fontSize: '.850rem',
    fontWeight: 'bold',
  },
  '@global .DayPicker-Caption': {
    fontSize: '1.125em',
    color: '#683caf',
  },
  '@global .DayPicker-Caption > div': {
    fontWeight: 'normal',
  },
  '@global .DayPicker-Month': {
    borderSpacing: '0 .5em !important',
    borderCollapse: 'separate',
  },
  '@global .selectable .DayPicker-Week .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside):first-child': {
    borderRadius: '50% 0 0 50% !important',
  },
  '@global .selectable .DayPicker-Week .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside):last-child': {
    borderRadius: '0 50% 50% 0 !important',
  },
  '@global .selectable .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside)': {
    backgroundColor: '#eae3f4 !important',
    color: '#585858',
  },
  '@global .selectable .DayPicker-Day': {
    borderRadius: '0 !important',
    padding: '.35em 0.5em !important',
  },
  '@global .selectable .DayPicker-Day--start': {
    backgroundColor: '#683caf !important',
    borderRadius: '50% 0 0 50% !important',
    color: '#fff !important',
  },
  '@global .selectable .DayPicker-Day--end': {
    backgroundColor: '#683caf !important',
    borderRadius: '0 50% 50% 0 !important',
    color: '#fff !important',
  },
  '@global .selectable .DayPicker-Day--start.DayPicker-Day--end': {
    borderRadius: '1rem !important',
  },
  '@global .DayPicker-Weekday': {
    textTransform: 'uppercase',
  },
  '@global .selectable .DayPicker-Day--start:focus': {
    outline: 0,
  },
  '@global .selectable .DayPicker-Day--end:focus': {
    outline: 0,
  },
  '@global .DayPicker-wrapper:focus': {
    outline: 0,
  },
  '@global .DayPicker-Day--selected.DayPicker-Day--outside': {
    backgroundColor: 'transparent !important',
  },
};

export default styles;
